import MapboxGlDraw from '@mapbox/mapbox-gl-draw';
import FreehandMode from './freehand-mode';

const FeaturesWithin = Object.assign({}, FreehandMode);

FeaturesWithin.onSetup = function (opts) {
  const onSetup = FreehandMode.onSetup.bind(this);
  const state = onSetup();
  this.map.fire(MapboxGlDraw.constants.events.MODE_CHANGE, {
    mode: opts.mode,
  });
  state.polygon.setProperty('type', opts.actionType);
  return state;
};

FeaturesWithin.onKeyUp = function (state, e) {
  if (MapboxGlDraw.lib.CommonSelectors.isEscapeKey(e)) {
    this.deleteFeature([state.polygon.id], { silent: true });
    this.changeMode(MapboxGlDraw.constants.modes.SIMPLE_SELECT);
  } else if (MapboxGlDraw.lib.CommonSelectors.isEnterKey(e)) {
    this.simplify(state.polygon);
    this.changeMode(MapboxGlDraw.constants.modes.SIMPLE_SELECT, {
      featureIds: [state.polygon.id],
    });
    this.deleteFeature([state.polygon.id], { silent: true });
  }
};

FeaturesWithin.onMouseUp = function (state, e) {
  if (state.dragMoving) {
    this.simplify(state.polygon);
    this.fireUpdate();
    this.changeMode(MapboxGlDraw.constants.modes.SIMPLE_SELECT, {
      featureIds: [state.polygon.id],
    });
    this.deleteFeature([state.polygon.id], { silent: true });
  }
};

FeaturesWithin.clickAnywhere = function (state, e) {
  if (
    state.currentVertexPosition > 0 &&
    MapboxGlDraw.lib.isEventAtCoordinates(
      e,
      state.polygon.coordinates[0][state.currentVertexPosition - 1],
    )
  ) {
    this.simplify(state.polygon);
    this.changeMode(MapboxGlDraw.constants.modes.SIMPLE_SELECT, {
      featureIds: [state.polygon.id],
    });
    this.deleteFeature([state.polygon.id], { silent: true });
  }
  this.updateUIClasses({ mouse: MapboxGlDraw.constants.cursors.ADD });
  state.polygon.updateCoordinate(
    `0.${state.currentVertexPosition}`,
    e.lngLat.lng,
    e.lngLat.lat,
  );
  state.currentVertexPosition++;
  state.polygon.updateCoordinate(
    `0.${state.currentVertexPosition}`,
    e.lngLat.lng,
    e.lngLat.lat,
  );
};

FeaturesWithin.clickOnVertex = function (state) {
  this.simplify(state.polygon);
  this.changeMode(MapboxGlDraw.constants.modes.SIMPLE_SELECT, {
    featureIds: [state.polygon.id],
  });
  this.deleteFeature([state.polygon.id], { silent: true });
};

export default FeaturesWithin;
